import { useEffect } from 'react';
import { Elements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';
import { getConfig } from '../../utils/config';
import { notify } from '../../utils/notification';

const { stripePublishableKey } = getConfig();
const stripePromise = loadStripe(stripePublishableKey);

export const StripePaymentResultNotificator = ({ onError }: { onError?: () => void }) => {
  const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

  if (!clientSecret) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      {clientSecret ? (
        <StripePaymentResultNotificationWithContext clientSecret={clientSecret} onError={onError} />
      ) : null}
    </Elements>
  );
};

const StripePaymentResultNotificationWithContext = ({
  clientSecret,
  onError,
}: {
  clientSecret: string;
  onError?: () => void;
}) => {
  const stripe = useStripe();
  const { t } = useTranslation('payment');

  /**
   * Handle stripe payment statuses and errors
   */
  useEffect(() => {
    if (!stripe) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent?.status) {
        case 'succeeded':
          notify.positive({ message: t('notification.success') });
          break;
        case 'processing':
          notify.neutral({ message: t('notification.processing') });
          break;
        default:
          notify.negative({ message: t('notification.error') });
          onError?.();
          break;
      }
    });
    // eslint-disable-next-line
  }, [clientSecret, stripe]);

  return null;
};
